import "./index.scss";
import React, { Profiler } from "react";
import { useSelector } from "react-redux";
import "./App.css";
import App_Admin from "./App_Admin";
import App_Agent from "./App_Agent";
function App() {
  const user = useSelector((state) => state.AuthReducer.user);

  return (
    <>
      <Profiler id="my_erp" onRender={callback}>
        {user.role !== "agent" && user.role !== "accountant" ? (
          <App_Admin />
        ) : (
          <App_Agent />
        )}
      </Profiler>
    </>
  );
}
function callback(
  id, // id of the Profiler component
  phase, // either "mount" (if the component is being mounted) or "update" (if it's being updated)
  actualDuration, // time taken to render the component
  baseDuration, // time expected to render the component
  startTime, // time the rendering started
  commitTime, // time the rendering was committed
  interactions // Set of interactions that were being processed during this update
) {
  // log the performance metrics to the console
  // console.log(`${id}'s ${phase} phase:`);
  // console.log(`Actual duration: ${actualDuration}ms`);
  // console.log(`Base duration: ${baseDuration}ms`);
  // console.log("startTime", startTime);
  // console.log("commitTime", commitTime);
}
export default App;
